module.exports = __webpack_public_path__ + "img/空白（版心宽+静态文字）.40c0f520.jpg";